import { HttpHeaders } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export const HTTPOPTIONS = new InjectionToken<HttpHeaders>('Options');
export const ENTRYPOINT = new InjectionToken<string>('EntryPoint');
export const CHARONSERVICE = new InjectionToken<string>('CharonService');
export const CONFIG = new InjectionToken('CryptoConfig');
